import { Add } from '@mui/icons-material'
import { AutocompletePaperSlotPropsOverrides, Paper, PaperProps, Stack, styled, Typography } from '@mui/material'
import isFunction from 'lodash/isFunction'

type AssigneeAutocompletePaperProps = {
  onAddNew: (() => void) | undefined
  addNewText: string | undefined
  setIsOpen: (isOpen: boolean) => void
} & PaperProps &
  AutocompletePaperSlotPropsOverrides

export const AssigneeAutocompletePaper = ({
  onAddNew,
  addNewText,
  setIsOpen,
  children,
  ...rest
}: AssigneeAutocompletePaperProps) => {
  return (
    <Paper {...rest}>
      <Stack>{children}</Stack>
      {isFunction(onAddNew) && addNewText && (
        <Paper>
          <AddNewButton
            onMouseDown={(event) => {
              event.preventDefault()
              setIsOpen(false)
              onAddNew()
            }}
          >
            <Add sx={{ marginRight: 2, fontSize: '20px', color: 'neutralLight.700' }} />

            <Typography color="primary.main" variant="Body14pxRegular">
              {addNewText}
            </Typography>
          </AddNewButton>
        </Paper>
      )}
    </Paper>
  )
}

const AddNewButton = styled('button')(({ theme }) => ({
  height: '48px',
  backgroundColor: theme.palette.neutralLight[0],
  ':hover': {
    backgroundColor: theme.palette.neutralLight[50],
  },
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  padding: '12px 16px',
  width: '100%',
  border: 'none',
}))
